import React from "react";
import ReactDOM from "react-dom";
import "../../../_assets/sass/components/_layoutModal.scss";
import { Modal, Button } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

interface InputProps {
  children: any;
  title: string;
  onHide: any;
}

const ModalLayout = React.forwardRef<HTMLInputElement, InputProps>(
  (props, ref) => {
    return ReactDOM.createPortal(
      <>
        <Modal
          {...props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          scrollable={true}
          centered
        >
          <Modal.Header closeButton className="d-flex flex-column">
            <Modal.Title id="contained-modal-title-vcenter">
              {props.title}
            </Modal.Title>
            <Modal.Body
              className="w-100"
              style={{
                maxHeight: "calc(100vh - 210px)",
                overflowY: "auto",
              }}
            >
              {props.children.body}
            </Modal.Body>
          </Modal.Header>
          <Modal.Footer>
            {props.children.footer}
            <Button
              variant="secondary"
              id="modalDismissId"
              onClick={props.onHide}
            >
              <FormattedMessage id="AUTH.GENERAL.CANCEL_BUTTON" />
            </Button>
          </Modal.Footer>
        </Modal>
      </>,
      document.getElementById("layout-portal")
    );
  }
);

export default ModalLayout;
